<template>
  <div class="homePage scroll">
    <div class="chatCont" ref="chatCont">
      <video :src="bgMp4Url" class="bgMp4" autoplay muted ref="bgMp4" @loadeddata="videoLoad"
        :class="bgMp4Class"></video>
      <div class="flex-ac flex-c home-title layout">
        <img src="@/assets/img/机器人头 1@2x.png" alt="" style="height: 50px" />
        <h1>从择校到入校，您的<i>AI留学管家</i></h1>
      </div>
      <h2>覆盖全球9000+院校，一键申请、签证、住宿全搞定</h2>
      <div class="textareaCont" id="textareaCont" ref="textareaCont">
        <el-input class="no-border-textarea" v-model="question" type="textarea" resize="none"
          :placeholder="pattern.find(it => it.value == patternOn).text"
          :input-style="{ border: 'none', outline: 'none' }" @keydown.enter="searchSubmit()" />
        <span class="statistics">已有 <i>{{ statistics }}</i> 位同学拿到offer</span>
        <el-popover placement="top" popper-class="modelPopper" transition="modelPopper">
          <div v-for="(it, i) in pattern" :key="i" class="flex-ac flex-start pointer" @click="patternOn = it.value">
            <span>{{ it.name }}</span>
          </div>
          <template #reference>
            <span class="chatType flex-ac flex-c pointer">模式：{{pattern.find(it => it.value == patternOn).name}}</span>
          </template>
        </el-popover>

        <img src="@/assets/img/Group 740@2x.png" alt="" class="filesIcon pointer" v-if="false" />
        <img src="@/assets/img/Group 717@2x.png" alt="" class="sendIcon pointer" @click="searchSubmit" />
      </div>
      <!-- <div class="quickQuestion flex-ac flex-c fw">
        <p v-for="(it, i) in quickQuestion" :key="i" class="pointer flex-ac flex-c">
          <span>{{ it }}</span>
        </p>
      </div> -->
    </div>
    <StepCont />
    <!-- <CaseCont /> -->
    <ToolCont />
    <BottomCont />
  </div>
</template>
<script setup>
import StepCont from "@/components/StepCont.vue";
import CaseCont from "@/components/CaseCont.vue";
import ToolCont from "@/components/ToolCont.vue";
import BottomCont from "@/components/BottomCont.vue";

import {
  ref,
  computed,
  onMounted,
  onBeforeMount,
  onBeforeUnmount,
  watch,
  nextTick,
} from "vue";

import { storeToRefs } from "pinia";
import { useStore } from "@/store";
import { useRouter } from "vue-router";
const quickQuestion = ref([
  "输入你的背景，AI为你生成专属名校升学方案",
  "双非均分85，想申英国传媒硕士",
  "预算5 0万，适合去哪个国家？",
]);

const pattern = ref([
  { name: "资深顾问", value: 'normalChat', text: "可以问任何问题" },
  { name: "择校专家", value: 'chooseSchool', text: "请输入您的意向国家，毕业学校，本科专业，GPA(百分制)" },
  // { name: "档案专家", value: '', text: "开始打造高成功率CV，请投喂简历文档或发送个人信息，Al专家即刻为你完成简历优化与专业排版" },
  { name: "文书专家", value: 'fileMade', text: "欢迎进入PS文书工坊，我们可以润色已有草稿以提升学术深度，或帮你从零构建文书。" },
])
const patternOn = ref('normalChat');

const router = useRouter();

const store = useStore();
const { theme, userLoginInfo, isSend, openLogin } = storeToRefs(store);
const { setOpenLogin, setQuestion } = store;

const question = ref("");
const statistics = ref(12345);
const headCont = ref(null);
const bgMp4Url = ref("");
const bgMp4 = ref(null);
const bgMp4Class = ref(null);
const chatCont = ref(null);

const searchSubmit = () => {
  if (!question.value) return
  if (!userLoginInfo.value) {
    setOpenLogin(false)
    setOpenLogin(true)
  } else {
    setQuestion({ question: question.value, type: patternOn.value })
    router.push({ name: "chat" });
  }
};

watch(userLoginInfo, (v) => {
  if (v) {
    if (question.value.trim()) {
      router.push({ name: "chat" });
    }
  }
})
onBeforeMount(() => {
  bgMp4Url.value = require("@/assets/madia/bgMp4.mp4")

})
const setBgMp4Ratio = () => {
  try {
    let videoRatio = (bgMp4.value.videoWidth / bgMp4.value.videoHeight).toFixed(2)
    let contRatio = (chatCont.value.clientWidth / chatCont.value.clientHeight).toFixed(2)
    if (videoRatio > contRatio) {
      bgMp4Class.value = 'height'
    } else {
      bgMp4Class.value = 'width'
    }
  } catch (err) {
  }
}

const videoLoad = () => {
  setBgMp4Ratio()
  addEventListener("resize", setBgMp4Ratio)
}

onBeforeUnmount(() => {
  window.removeEventListener('resize', setBgMp4Ratio)
})

</script>
<style lang="scss" scoped>
.homePage {
  height: calc(100vh - 66px);
}

.chatCont {
  background: #BDD4EA;
  padding: 100px 0 90px;
  margin: 0 auto;
  box-shadow: none;
  border-radius: 0;

  .bgMp4 {
    position: absolute;
    bottom: 0;
    z-index: 1;
    left: 0;
  }

  .bgMp4.width {
    width: 100%;
    height: auto;
    object-fit: cover;
  }

  .bgMp4.height {
    width: auto;
    height: 100%;
    object-fit: cover;
  }
}

.homePage.isSend {
  background: #fafafa;
  box-shadow: 0px 2px 4px 0px rgba(0, 14, 67, 0.06);
  border-radius: 16px 16px 16px 16px;
  width: 100%;
  height: 100%;
  padding: 16px;

  .inputBox {
    background: rgba(255, 255, 255, 0.75);
    box-shadow: 0px 2px 4px 0px rgba(0, 14, 67, 0.06);
    border-radius: 16px 16px 16px 16px;
    width: calc(100% - 230px - 16px);
    height: 100%;
    margin-left: calc(230px + 16px);
  }
}

.home-title {
  img {
    height: 50px;
    margin-right: 20px;
    z-index: 55;
  }
}

h1 {
  color: #393d4b;
  font-size: 40px;
  font-weight: 600;
  text-align: center;
  line-height: 56px;
  letter-spacing: 2px;
  z-index: 55;

  i {
    font-weight: 900;
    background: #4284FF;
    -webkit-background-clip: text;
    background-clip: text;
    -webkit-text-fill-color: transparent;
    color: transparent;
  }
}

h2 {
  z-index: 55;
  color: #393d4b;
  font-size: 16px;
  margin: 16px auto 40px;
  text-align: center;
  line-height: 22px;
}

.quickQuestion {
  margin-top: 40px;

  p {
    word-spacing: normal;
    border-radius: 20px;
    font-size: 14px;
    color: #9eaec5;
    margin: 8px;
    z-index: 2;
    overflow: hidden;
    padding: 1px;

    &:hover {

      &::after,
      &::before {
        content: "";
        position: absolute;
        width: 400px;
        height: 400px;
        background-image: conic-gradient(from var(--angle),
            #5b23ff,
            #ffde42,
            #008bff,
            #ff52a0,
            #5b23ff);
        z-index: -1;
        display: block;
        border-radius: 20px;
        top: calc(50% - 200px);
        left: calc(50% - 200px);
        animation: 2s rotate linear infinite;
      }
    }

    &::before {
      filter: blur(1.5rem);
      opacity: 0.2;
    }

    span {
      word-spacing: normal;
      line-height: 20px;
      background: #ffffff;
      border-radius: 20px;
      border: 1px solid #d5e0ee;
      font-size: 14px;
      color: #9eaec5;
      padding: 8px 16px;
      z-index: 2;
    }

    &:hover {
      span {
        color: #6c7b92;
      }
    }
  }
}

@property --angle {
  syntax: "<angle>";
  initial-value: 0deg;
  inherits: false;
}

@keyframes rotate {
  0% {
    transform: rotate(0deg);
  }

  100% {
    transform: rotate(360deg);
  }
}

.chatBox {
  max-width: 900px;
  width: 100%;
  padding: 16px;
  margin: 0 auto;
}

.textareaCont {
  z-index: 55;
  max-width: 900px;
  width: 100%;
  padding: 20px 20px 60px;
  height: 258px;
  background: rgba(255, 255, 255, 0.75);
  box-shadow: 0px 0px 4px 0px rgba(0, 14, 67, 0.06);
  border-radius: 40px;
  border: 1px solid #edf5ff;
  margin: 0 auto;
  backdrop-filter: blur(4px);


  .el-textarea {
    width: 100%;
    height: 100%;
  }

  ::v-deep .el-textarea__inner {
    width: 100%;
    height: 100%;
    padding: 0;
  }

  .filesIcon {
    width: 40px;
    position: absolute;
    bottom: 20px;
    right: calc(20px + 40px + 12px);
    z-index: 9;
  }

  .sendIcon {
    width: 40px;
    position: absolute;
    bottom: 20px;
    right: 20px;
    z-index: 9;
  }

  .statistics {
    position: absolute;
    bottom: 20px;
    left: 20px;
    z-index: 9;
    line-height: 22px;
    background: #f4f7fb;
    border-radius: 11px 11px 11px 11px;
    font-size: 12px;
    color: #6c7b92;
    padding: 0 13px;

    i {
      color: #FF9C11;
    }
  }
}

.no-border-textarea {
  font-size: 16px;

  // 方法1: 使用 :deep() 深度选择器
  :deep(.el-textarea__inner) {
    border: none !important;
    /* 移除边框 */
    outline: none !important;
    /* 移除聚焦时的轮廓 */
    box-shadow: none !important;
    /* 移除阴影 */

    /* 可选：设置背景色与外部背景一致 */
    background-color: transparent;

    /* 可选：移除聚焦时的边框 */
    &:focus {
      border: none !important;
      outline: none !important;
      box-shadow: none !important;
    }

    /* 可选：移除悬浮时的边框 */
    &:hover {
      border: none !important;
    }
  }
}

.homePage.dark {
  background: url(@/assets/img/bg@2x.png) no-repeat;
  background-size: 100% 100%;

  h1 {
    color: #fff;
  }

  h2 {
    color: #fff;
  }

  .textareaCont {
    background: rgba(85, 86, 107, 0.8);
    border: 1px solid transparent;

    ::v-deep .el-textarea__inner {
      color: #fff;
    }
  }

  .quickQuestion p {
    padding: 2px;
  }
}

.chatType {
  position: absolute;
  bottom: 20px;
  right: 130px;
  z-index: 9;
  background: #FFFFFF;
  box-shadow: 0px 0px 4px 0px rgba(0, 0, 0, 0.15);
  border-radius: 8px 8px 8px 8px;
  font-size: 12px;
  color: #333333;
  padding: 4px 16px;
}
</style>
<style lang="scss">
.modelPopper {
  width: 118px !important;
  min-width: 118px !important;
  background: #FFFFFF !important;
  box-shadow: 0px 0px 4px 0px rgba(0, 0, 0, 0.15) !important;
  border-radius: 8px 8px 8px 8px !important;
  padding: 0 4px !important;


  span {
    font-size: 12px;
    color: #333333;
    line-height: 12px;
  }

  .pointer {
    width: 110px;
    border-radius: 6px 6px 6px 6px;
    padding: 10px 14px;

    &:hover {
      background: #F8FBFF;
    }
  }
}
</style>